import { useMutation } from 'react-query';

import { setSubProgramPreferenceP6ExcelExport as mutationFn } from 'api/endPoints/setSubProgramPreferenceP6ExcelExport';

export const useMutationSetExcelExportConfig = () => {
    return useMutation<any, QueryError, ISetExcelExportConfig>((params) => mutationFn(params));
};

interface ISetExcelExportConfig {
    contractId: number;
    isExtractRemainingDuration: boolean;
    isExtractPercentageComplete: boolean;
    userData: string;
}
